/**
 * Rank-interleave several ranked lists: every list's first item, then every
 * list's second, in list order. Used by Search everything's All tab: the three
 * engines' scores live on different scales, so a raw-score sort let one kind
 * monopolise the top (live 2026-09-11: five collaborators before any grant).
 */
export function InterleaveByRank<T>(lists: ReadonlyArray<readonly T[]>): T[] {
    const out: T[] = [];
    const longest = lists.reduce((max, list) => Math.max(max, list.length), 0);
    for (let rank = 0; rank < longest; rank++) {
        for (const list of lists) {
            if (rank < list.length) out.push(list[rank]);
        }
    }
    return out;
}
